import {useEffect, useState} from "react";
import {useAddItem} from "./useAddItem";
import {X} from "lucide-react";
import {useCatalog} from "../../useCatalog";


const AddItemModal = ({onClose, categories}: any) => {
    const [itemType, setItemType] = useState<'service' | 'product'>('service');
    const [formData, setFormData] = useState<any>({
        name: '', description: '', category_id: null, duration: 30, price: 0, stock: 0, notes: ''
    });




    const {addItem} = useAddItem({
        onSuccess: () => {
            onClose();
        },

    });

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        const newItem = {
            title: formData.name,
            description: formData.description,
            service_category_id: formData.category_id,
            price: formData.price,
            type: itemType, ...(itemType === 'service' ? {duration: formData.duration, notes: formData.notes} : {stock: formData.stock})
        };

        await addItem(newItem);
        // onAdd(newItem); // still notify parent
    };
    // Reset category when switching types
    const handleTypeChange = (type: 'service' | 'product') => {
        setItemType(type);
        setFormData({...formData, category: ''});
    };




    return (<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-lg w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-6 border-b border-gray-200"><h3
                className="text-lg font-semibold text-gray-900"> Add New Item </h3>
                <button onClick={onClose} className="text-gray-400 hover:text-gray-600"><X className="w-5 h-5"/>
                </button>
            </div>
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
                <div><label className="block text-sm font-medium text-gray-700 mb-2"> Type </label>
                    <div className="flex space-x-4"><label className="flex items-center">
                        <input type="radio"
                               name="itemType"
                               value="service"
                               checked={itemType === 'service'}
                               onChange={(e) => handleTypeChange(e.target.value as 'service' | 'product')}
                               className="mr-2 text-blue-600 focus:ring-blue-500"/>
                        <span className="text-sm text-gray-700">Service</span> </label>
                        <label className="flex items-center">
                            <input type="radio" name="itemType" value="product"
                                   checked={itemType === 'product'}
                                   onChange={(e) => handleTypeChange(e.target.value as 'service' | 'product')}
                                   className="mr-2 text-blue-600 focus:ring-blue-500"/>
                            <span className="text-sm text-gray-700">Product</span> </label>
                    </div>
                </div>
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1"> Name </label>
                        <input
                            type="text" value={formData.name}
                            onChange={(e) => setFormData({...formData, name: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required/>
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1"> Category </label>
                        <select
                            value={formData.category_id || 0 }
                            onChange={(e) => setFormData({...formData, category_id: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            required>
                            <option value="">Select category</option>
                            {categories[itemType].map((cat: any) => (
                                <option key={cat.id} value={cat.id}>{cat.name}</option>))} </select>
                    </div>
                </div>
                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1"> Description </label>
                    <textarea
                        value={formData.description}
                        onChange={(e) => setFormData({...formData, description: e.target.value})}
                        className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        rows={3} required/>
                </div>
                {itemType === 'service' && (
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1"> Notes </label>
                        <textarea
                            value={formData.notes}
                            onChange={(e) => setFormData({...formData, notes: e.target.value})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            rows={3} placeholder="Enter service notes"/>
                    </div>
                )}
                <div className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1"> Price ($) </label>
                        <input
                            type="number" value={formData.price}
                            onChange={(e) => setFormData({...formData, price: parseFloat(e.target.value)})}
                            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                            min="0" step="0.01" required/>
                    </div>
                    {itemType === 'service' ? (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1"> Duration
                                (minutes) </label>
                            <input type="number" value={formData.duration}
                                   onChange={(e) => setFormData({
                                       ...formData,
                                       duration: parseInt(e.target.value)
                                   })}
                                   className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                   min="1" required/>
                        </div>) : (
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-1"> Stock </label>
                            <input
                                type="number" value={formData.stock}
                                onChange={(e) => setFormData({...formData, stock: parseInt(e.target.value)})}
                                className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                min="0" required/></div>)}
                </div>
                <div className="flex justify-end space-x-3 pt-4">
                    <button type="button" onClick={onClose}
                            className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-50"> Cancel
                    </button>
                    <button type="submit"
                            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"> Add {itemType === 'service' ? 'Service' : 'Product'} </button>
                </div>
            </form>
        </div>
    </div>);
}
export default AddItemModal
